import * as cryptojs from "crypto-js";
import * as dexie from "dexie";
import * as brotlidecode from "./node_modules/brotlidecode/decode.min.js";


window.CryptoJs = {};
window.CryptoJs.default = {};

Object.assign(window, brotlidecode);
Object.assign(window, dexie);
Object.assign(window.CryptoJs.default, cryptojs);